import deepmerge from 'deepmerge'
import dutchMessages from 'ra-language-dutch'

import nl from './nl.json'

export default deepmerge.all([dutchMessages, nl])
